import React from "react";
import Navbar from "./Navbar";
import Footers from "./Footer";
import { motion } from "framer-motion";

const FittedBedroom = () => {
  return (
    <motion.div 
    className="page-wraper" 
    style={{ background: "#fff" }}
    initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
  >
      <Navbar />

      <div className="page-content">
        {/* top conatin start  */}
        <div
          className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
          data-stellar-background-ratio="0.5"
          style={{ backgroundImage: "url(/assets/pic/fitterbed.jpg)" }}
       
        >
          <div className="overlay-main bg-black opacity-07"></div>
          <div className="container">
            <div className="wt-bnr-inr-entry">
              <div className="banner-title-outer">
                <div className="banner-title-name">
                  <h2 className="text-white">Fitted Bedrooms</h2>
                </div>
              </div>

              <div>
                <ul className="wt-breadcrumb breadcrumb-style-2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Fitted Furniture</li>
                  <li>Fitted Bedrooms</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* top conatin end  */}
        {/* text start  */}
        <motion.div  className="container mt-5">
          <div className="project-detail-outer">
            <div className="project-detail-containt">
              <div className=" text-black">
                <h3 style={{color:'#B19777'}}>
                  Transform Your Bedroom into a Serene and Organized Space with
                  Custom Fitted Wardrobes
                </h3>
                <p style={{color:'#000'}}>
                Your bedroom is  more than just a place to sleep—it is your personal retreat. A space where you  truly relax, feel at ease, and be yourself.
                </p>

                <p style={{color:'#000'}}>
                In our busy lives, having somewhere to unwind and recharge isn’t a luxury—it’s essential. 
                
                </p>
                <p style={{color:'#000'}}>
                  That’s why we design bedrooms that go beyond comfort, blending beauty with smart functionality. From elegant wardrobes and bespoke dressing areas to cosy beds and side tables, every detail is thoughtfully crafted. From the first idea to the smallest finishing touch, we’re with you every step of the way, creating a bedroom that looks beautiful, works perfectly, and feels truly yours.
                </p>
              </div>
            </div>
            <div className="project-detail-containt">
              <div className=" text-black">
                <h3 style={{color:'#B19777'}}>
            Why bespoke works best:
                </h3>
                <p style={{color:'#000',marginBottom:'10px'}}>
         •	Perfect for tricky spacesots like low ceilings or awkward corners.
                </p>

                <p style={{color:'#000',marginBottom:'20px'}}>
        •	Makes the most of your space without ever compromising on style.
                </p>
                
              </div>
            </div>

 <div className="project-detail-containt">
              <div className=" text-black">
                <h3 style={{color:'#B19777'}}>
            Features:
                </h3>
                <p style={{color:'#000',marginBottom:'10px'}}>
         •	Beautifully designed with luxurious finishes
                </p>

                <p style={{color:'#000',marginBottom:'10px'}}>
        •	Smart, bespoke storage that works for you
                </p>


                    <p style={{color:'#000',marginBottom:'10px'}}>
        •	Layouts and solutions tailored to your home and lifestyle
                </p>
                
              </div>
            </div>


          </div>
        </motion.div >
        {/* text end  */}

        {/* card start  */}
        <motion.div  className="container mt-5">
          <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
            <div className="masonry-item cat-1 col-lg-4 col-md-6 col-sm-12 m-b30">
              <div className="project-img-effect-1">
                <img
                  // src="assets/images/gallery/pic1.jpg"
                  src="/assets/pic/kuahb-wd.jpg"
                  alt=""
                />
                <div className="wt-info">
                  <h4 className="wt-tilte text-white  m-b10 m-t0">
                    Guaranteed quality
                  </h4>
                  <p>
                    At CraftMySpace, we ensure top-notch quality in every
                    piece of furniture we create. Our products are crafted with
                    precision, using premium materials for durability and
                    elegance.
                  </p>
                </div>
              </div>
            </div>
            <div className="masonry-item cat-2 col-lg-4 col-md-6 col-sm-12 m-b30">
              <div className="project-img-effect-1">
                <img
                  // src="assets/images/gallery/pic2.jpg"
                  src="/assets/pic/design-and-rende.jpg"
                  alt=""
                />
                <div className="wt-info">
                  <h4 className="wt-tilte text-white  m-b10 m-t0">
                    Professional installation
                  </h4>
                  <p>
                    At CraftMySpace, we provide expert installation services
                    to ensure your furniture is set up perfectly. Our skilled
                    professionals handle every detail with care for a
                    hassle-free experience.
                  </p>
                </div>
              </div>
            </div>
            <div className="masonry-item cat-3 col-lg-4 col-md-6 col-sm-12 m-b30">
              <div className="project-img-effect-1">
                <img
                  // src="assets/images/gallery/pic3.jpg"
                  src="/assets/pic/bedroom3.jpg"
                  alt=""
                />
                <div className="wt-info">
                  <h4 className="wt-tilte text-white  m-b10 m-t0">
                    Convenience of choice
                  </h4>
                  <p>
                    At CraftMySpace, we offer a wide range of furniture styles
                    to suit every taste and need. Choose from our diverse
                    collection to find the perfect fit for your space
                    effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div >
        {/* card end  */}


    <Footers />

      </div>

      <button className="scroltop">
        <span className="fa fa-angle-up  relative" id="btn-vibrate"></span>
      </button>
    </motion.div >
  );
};

export default FittedBedroom;
